"use client";

import { lazy } from "react";
import type { ToolUIRegistry } from "../../tool-renderer";

export const knowledgeEngineToolRegistry = {
  legacyKnowledgeSearch: {
    kind: "step",
    category: "research",
    view: lazy(() =>
      import("./search").then(({ LegacyKnowledgeSearchToolView }) => ({
        default: LegacyKnowledgeSearchToolView,
      }))
    ),
  },
  getNodeDetails: {
    kind: "step",
    category: "research",
    view: lazy(() =>
      import("./get-node").then(({ GetNodeDetailsToolView }) => ({
        default: GetNodeDetailsToolView,
      }))
    ),
  },
  getConfluenceAttachment: {
    kind: "step",
    category: "research",
    view: lazy(() =>
      import("./get-attachment").then(
        ({ GetConfluenceAttachmentToolView }) => ({
          default: GetConfluenceAttachmentToolView,
        })
      )
    ),
  },
  expandGraph: {
    kind: "step",
    category: "research",
    view: lazy(() =>
      import("./expand-graph").then(({ ExpandGraphToolView }) => ({
        default: ExpandGraphToolView,
      }))
    ),
  },
} satisfies ToolUIRegistry;
